import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-dark-blue/theme.css';
import 'primereact/resources/primereact.css';
// import 'primeflex/primeflex.css';
import './_override.scss';

import React, { Suspense, useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { getAppRoutes } from './services/RouteService';
import { AuthGuardProvider } from './authentacation/AuthGuard';
// import { SocketIOProvider } from './core/SocketIOProvider';
import { ToastProvider } from './toast/ToastContext';
import { ProgressSpinner } from 'primereact/progressspinner';
import SplashScreen from './component/SplashScreen';

function App() {
  const location = useLocation();
  const routes = getAppRoutes();
  const navigateState = useNavigate();
  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();
  useEffect(() => {
    // On mobile browsers, localStorage works the same as on desktop.
    // This code saves all URL search params to localStorage.
    for (const [key, value] of searchParams.entries()) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        // Handle storage quota exceeded or private mode issues
        console.warn('Could not save to localStorage:', e);
      }
    }

    // Check if macAddress is missing or empty
    const mac = localStorage.getItem('clientMac');
    if (!mac && location.pathname !== '/nomacaddress') {
      setLoading(false);
      navigateState('/nomacaddress');
    }

    setLoading(false);

  }, [navigateState, searchParams, location.pathname,]);

  if (loading)
    return <SplashScreen message="Loading Parameters..." />;

  return (
    <ToastProvider>
      <Suspense fallback={<SplashScreen message="Loading..." />}>
        <Routes>
          {routes.map(({ path, element, guard, socket }) => {
            let wrappedElement = element;
            // if (guard && socket?.status) {
            //   wrappedElement = <AuthGuardProvider><SocketIOProvider
            //     url={`${socket.url}`}
            //     path={socket.path || "/pesowifi-socket"}>
            //     {wrappedElement}
            //   </SocketIOProvider></AuthGuardProvider>;
            //   return <Route key={path} path={path} element={wrappedElement} />;
            // }

            // if (socket?.status) {
            //   wrappedElement = (
            //     <SocketIOProvider
            //       url={`${socket.url}`}
            //       path={socket.path || "/pesowifi-socket"}
            //     >
            //       {wrappedElement}
            //     </SocketIOProvider>
            //   );
            //   return <Route key={path} path={path} element={wrappedElement} />;
            // }

            if (guard) {
              wrappedElement = <AuthGuardProvider>{wrappedElement}</AuthGuardProvider>;
              return <Route key={path} path={path} element={wrappedElement} />;
            }

            return <Route key={path} path={path} element={wrappedElement} />;
          })}
        </Routes>
      </Suspense>
    </ToastProvider>
  );
}

export default App;